
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
import AppMissingModule from "@/components/common/MissingModule.vue";
import AppPriceRuleEdit from "@/components/price-rules/PriceRuleEdit.vue";
import { Browse } from "@/models/browse";
import { BrowseService } from "@/services";
import { IPriceRule } from "@/utils/price-rule";

type NewRuleConstructor = ()=>IPriceRule

export default Vue.extend({
	data(){
		return {
			toEditRule: null as IPriceRule | null
		};
	},
	props: {
		rules: {
			type: Array as ()=>IPriceRule[],
			required: true
		},
		defaultPriceCategory: Number,
		newRuleConstructor: {
			type: Function as any as ()=>NewRuleConstructor,
			required: true
		},
		saveRuleFunction: Function
	},
	computed: {
		isAllowed(): Boolean {
			return AuthService.hasModule(this.moduleId);
		},
		moduleId():number {
			return MODULE.PRIJSBEDING;
		},
		browse():Browse | null {
			return BrowseService.getBrowseWithoutViewSettings(7);
		},
		sortableAttributes():any{
			return {
				tag: "w-list",
				name: "flip-list"
			};
		}
	},
	methods: {
		onSorted(){
			this.rules.forEach((r,i)=>{
				console.log(r.ID, i);
				r.DisplayOrder = i;
			});
			this.$emit("sorted");
		},
		deleteRule(rule:IPriceRule){
			let i = this.rules.indexOf(rule);
			if (i == -1) {
				return;
			}
			this.rules.splice(i,1);
			this.$emit("delete-rule", rule);
		},
		editRule(rule:IPriceRule){
			this.toEditRule = rule;
		},
		addRule(){
			this.toEditRule = this.newRuleConstructor();
		},
		onRuleSaved(rule:IPriceRule){
			if (!this.toEditRule) return;
			let i = this.rules.indexOf(this.toEditRule);
			if (i == -1) {
				this.rules.push(rule);
			}else{
				this.$set(this.rules, i, rule);
			}
		},
		moveRuleUp(rule:IPriceRule){
			let i = this.rules.indexOf(rule);
			if (i < 1) return;
			let previousItem = this.rules[i-1];
			this.$set(this.rules, i, previousItem);
			this.$set(this.rules, i-1, rule);
			this.onSorted();
		},
		moveRuleDown(rule:IPriceRule){
			let i = this.rules.indexOf(rule);
			if (i >= this.rules.length-1) return;
			let nextItem = this.rules[i+1];
			this.$set(this.rules, i, nextItem);
			this.$set(this.rules, i+1, rule);
			this.onSorted();
		}
	},
	components: {
		AppMissingModule,
		AppPriceRuleEdit
	},
	i18nEx: {
		componentPrefix: "components.price-rules"
	}
});
